'use strict';

angular.module('msWidgets').directive('msWidgetMediaAlignedMedia', [function () {
  return {
    templateUrl: 'widgets/templates/media/aligned_media.html'
  };
}]).directive('msWidgetMediaAudio', [function () {
  return {
    templateUrl: 'widgets/templates/media/audio.html'
  };
}]).directive('msWidgetMediaAudioSpotify', [function () {
  return {
    templateUrl: 'widgets/templates/media/audio_spotify.html'
  };
}]).directive('msWidgetMediaImage', [function () {
  return {
    templateUrl: 'widgets/templates/media/image.html'
  };
}]).directive('msWidgetMediaVideoVimeo', [function () {
  return {
    templateUrl: 'widgets/templates/media/video_vimeo.html'
  };
}]).directive('msWidgetMediaVideoYoutube', [function () {
  return {
    templateUrl: 'widgets/templates/media/video_youtube.html'
  };
}]);